import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import OpenChatBot from '~/components/layout/Chatbot';
import Header from '~/components/layout/Header';
import NavigationCard from '~/components/pages/Portal/NavigationCard';
import CardSliderShowDefault from '~/components/pages/Portal/CardSliderShowDefault';
import SideBar from '~/components/layout/Sidebar';
import { orderGa } from '~/services/apiHandler';
import { aesEncrypt } from '~/utils/functions/cryptoHub';
import { analytics, logEvent } from '~/services/firebaseConfig';
import firebaseHandler from '~/services/firebaseHandler';
import OrderModal from '~/components/pages/Portal/OrderModal';
import EmployeeModal from '~/components/pages/Portal/EmployeeModal';
import ContactIcon from '@material-ui/icons/ContactsOutlined';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import { PendencyProvider, usePendency } from '~/hooks/pendency';
import api from '~/services/api';
import { isAuthorizedCore, isNewVisitHistoryCore } from '~/services/coreConfig';
import { getCommitment } from '~/services/commitmentService';
import useTrackWidget from '../../utils/functions/useTrackWidget';
import VisitModalController from '~/components/VisitModalController';

import {
  Container,
  Content,
  HeaderContainer,
  NavigationContainer,
  RefuelButton,
  RequestStatus,
  TrainingsButton,
  EmployeesButtonContainer,
  PageContainer,
  OrderContainerWeb,
  OrderContainerMobile,
  IconStatusOrder,
  OrderMessageError,
  PendencyQuantity,
  EmployeesStatusContainer,
  AreaBanner,
  AreaTwoCards,
  AreaOthersCards,
} from './styles';
import { LoadingStatusDesktop } from '~/components/layout/Loading';
import OrderCycle from '~/components/layout/OrderCycle';
import { handleStatusText } from '~/utils/functions/mapperStatusOrder';
import NpsRelational from '~/components/layout/NpsRelational';
import apiLapidar from '~/services/Lapidar/api';
import ModalExpiredInDays from '~/components/pages/SignIn/ModalExpiredInDays';
import { formatCNPJ, capitalizeFirstLetter } from '~/utils/utils';
import { hasTrainingCompliance } from '~/utils/functions/modals';
import { Creators } from '~/store/ducks/logistic';

function Home() {
  const { numberOfPendingIssues } = usePendency();
  const dispatch = useDispatch();
  const economicGroupReducer = useSelector(state => state.economicGroupReducer);
  const userReducer = useSelector(state => state.userReducer);
  const employeeReducer = useSelector(state => state.employeeReducer);
  const classificationReducer = useSelector(
    state => state.classificationReducer,
  );

  const npsReducer = useSelector(state => state.npsReducer);

  const notificationReducer = useSelector(state => state.notificationReducer);
  const loginReducer = useSelector(state => state.loginReducer);

  const [isShowPendency, setIsShowPendency] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hasHub, setHasHub] = useState(false);
  const [order, setOrder] = useState({});
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [orderMessage, setOrderMessage] = useState(false);
  const [firebaseStore, setFireBaseStore] = useState('');

  const storesState = [];
  const history = useHistory();
  const roles = useSelector(state => state.rolesReducer.roles);
  const [banners, setBanners] = useState([]);
  const [itemsSlider, setItemsSlider] = useState([]);
  const [modalOpenMessageExpiredInDays, setModalOpenMessageExpiredInDays] =
    useState(false);
  const [shouldLoadWidget, setShouldLoadWidget] = useState(false);
  const [visitData, setVisitData] = useState(null);

  const storeDocumentLocal = localStorage.getItem('storeDocument');
  const isMobile = window.screen.width < 771;
  const header = {
    method: 'POST',
    'Content-Type': 'application/json',
    access_token: localStorage.getItem('access_token'),
  };

  const parameters = {
    headers: header,
  };

  useEffect(() => {
    setIsShowPendency(numberOfPendingIssues > 0);
  }, [numberOfPendingIssues]);

  useEffect(() => {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      activeModalOrder();
      dispatch({
        type: 'ACTIVE_ORDER_MODAL',
        activeModal: { order: false, modal: false },
      });
      dispatch({
        type: 'ACTIVE_EMPLOYEE_MODAL',
        activeModal: { employee: false, modal: false },
      });
    } else {
      localStorage.clear();
      history.push('/acessar?error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!loading) {
      setLoading(true);
    }
    localStorage.setItem('urlTokenEncoded', false);
    const accessToken = localStorage.getItem('access_token');

    handleOrderGa(accessToken);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReducer.response]);

  useEffect(() => {
    setShowEmployeeModal(employeeReducer.activeModal.modal);
  }, [employeeReducer.activeModal]);

  useEffect(() => {
    const fetchToken = async () => {
      if (
        storeDocumentLocal &&
        roles &&
        economicGroupReducer.stores.length !== 0
      ) {
        const store = economicGroupReducer.stores.find(
          item => item.storeDocument === storeDocumentLocal,
        );
        if (firebaseStore === store) return;
        setFireBaseStore(store);
        try {
          await firebaseHandler.getToken(store, roles);
        } catch (error) {
          console.error('Erro ao obter token:', error);
        }
      }
    };

    fetchToken();
  }, [economicGroupReducer, storeDocumentLocal, roles]);

  useEffect(() => {
    loadDataIndeCxContact();
    loadDataMe();
    getStoreSummary();
    fetch();
  }, []);

  useEffect(() => {
    setTimeout(getLoginsForStore, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [npsReducer.openNpsScript]);

  useEffect(() => {
    if (
      npsReducer.openNpsScript &&
      !npsReducer.open &&
      notificationReducer.loadedPopup &&
      !notificationReducer.activePopup &&
      hasTrainingCompliance()
    ) {
      if (loginReducer.displayNotifyPassword) {
        setModalOpenMessageExpiredInDays(true);
        dispatch({
          type: 'DISPLAY_NOTIFY_PASSWORD',
          displayNotifyPassword: false,
        });
      }
    } else {
      if (npsReducer.open) {
        setModalOpenMessageExpiredInDays(false);
      }
    }
  }, [
    npsReducer,
    notificationReducer.loadedPopup,
    notificationReducer.activePopup,
  ]);

  async function loadDataIndeCxContact() {
    try {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const contactId = localStorage.getItem('contactIdSf');
      const storeId = localStorage.getItem('storeId');
      await api
        .get(
          `/residential/store/v1/stores/${storeId}/contacts/${contactId}`,
          parameters,
        )
        .then(res => {
          const cellPhone = res.data.cellPhoneAreaCode
            ? `(${res.data.cellPhoneAreaCode})-${res.data.cellPhoneNumber}`
            : '';
          localStorage.setItem('cellPhoneNumber', cellPhone);
        });
    } catch (error) {
      console.warn('Except in load data contact - Portal', error);
    }
  }

  async function getStoreSummary() {
    try {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const externalLoadIdOrStoreId = localStorage.getItem('external_load_id')
        ? localStorage.getItem('external_load_id')
        : localStorage.getItem('storeId');
      return await apiLapidar
        .get(
          `/store/summary?external_load_id=${externalLoadIdOrStoreId}`,
          parameters,
        )
        .then(res => {
          localStorage.setItem('category', res.data.rating);
          return res.data.rating;
        })
        .catch(err => {
          console.warn('Error in load summary data - Popup', err);
          return false;
        });
    } catch (error) {
      console.warn('Exceção in load summary - Popup', error);
      return false;
    }
  }

  async function loadDataMe() {
    try {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      return await api
        .get('residential/store/v1/stores/me', parameters)
        .then(res => {
          const isAuthorized = isAuthorizedCore(normalizeString(res.data.core));
          localStorage.setItem('segment', res.data.resaleSegmentation);
          localStorage.setItem('core', res.data.core);
          localStorage.setItem('market', res.data.market);
          localStorage.setItem('microMarket', res.data.microMarket);
          localStorage.setItem('branch', res.data.branch);
          localStorage.setItem('document', res.data.document);
          localStorage.setItem('state', res.data.address.stateAbbreviation);
          localStorage.setItem(
            'isAuthorizedCoreVisit',
            isAuthorized ? 'true' : 'false',
          );

          console.log(
            'isAuthorizedCore Login => ',
            isAuthorized,
            'core:',
            normalizeString(res.data.core),
          );

          if (isAuthorized) {
            fetchVisitConfirmations();
          }

          return res.data;
        })
        .catch(err => {
          console.err('Error in load store me - portal', err);
          return false;
        });
    } catch (error) {
      console.warn('Except in load store me - Portal', error);
      return false;
    }
  }

  async function getLoginsForStore() {
    setShouldLoadWidget(true);
  }

  const normalizeString = str => {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  };

  useTrackWidget(shouldLoadWidget, isMobile);

  const fetchVisitConfirmations = async () => {
    try {
      const id = localStorage.getItem('storeId');
      //const id = '0013000001MDsVWAA1';
      const res = await getCommitment(id);
      const data = Array.isArray(res.data) ? res.data : [];

      const core = localStorage.getItem('core');
      const isNewCore = isNewVisitHistoryCore(core);
      const minDateForNewCores = new Date('2026-03-12'); // 12/03/2026

      if (data.length > 0) {
        // Para núcleos antigos: mantém comportamento atual (qualquer compromisso não finalizado explicitamente com finished === false).
        // Para núcleos novos: considera compromissos EM ABERTO (finished === false) com commitmentDate >= 12/03/2026.
        const next = data.find(item => {
          const hasCommitmentDate = !!item.commitmentDate;

          if (!isNewCore) {
            // Núcleo antigo: usar exatamente a lógica anterior (finished === false)
            return item.finished === false;
          }

          // Núcleos novos
          if (!hasCommitmentDate) return false;

          const commitment = new Date(item.commitmentDate);
          const isAfterMinDate = commitment >= minDateForNewCores;

          // Para núcleos novos, só compromissos em aberto (finished === false) e após a data mínima
          return item.finished === false && isAfterMinDate;
        });

        if (next) {
          setVisitData(next);
        }
      }
    } catch (err) {
      console.warn('Erro ao buscar confirmação de visita', err);
    } finally {
    }
  };

  function activeModalOrder() {
    if (showOrderModal) {
      setShowOrderModal(false);
      dispatch({ type: 'ORDER_DONE' });
    } else {
      setShowOrderModal(true);
    }
  }

  async function handleOrderGa(access_token) {
    try {
      const header = {
        'Content-Type': 'application/json',
        access_token,
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const storeId = localStorage.getItem('storeId');
      orderGa(storeId, parameters)
        .then(res => {
          if (res.data.length > 0) {
            dispatch({ type: 'SET_ORDERS', orders: res.data });
            const newArray = [];
            res.data.map(obj => newArray.push(obj.number));
            const order = res.data;
            let lastOrder = order[0];
            for (let i = 1; i < order.length; ++i) {
              let orderNumer = parseInt(order[i].number);
              let lasOrderNumber = parseInt(lastOrder.number);
              if (orderNumer > lasOrderNumber) {
                lastOrder = order[i];
              }
            }
            setOrderMessage(false);
            setOrder(lastOrder);
          } else {
            setOrder([]);
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            setOrderMessage(true);
          }
        })
        .finally(() => setLoading(false));
    } catch (error) {
      console.warn('Except in handle order GA - Portal', error);
    }
  }

  async function fetchTrackingRead(payload) {
    try {
      await api
        .put('/customer-relationship/sitel/v1/reads', payload, parameters)
        .then(res => {})
        .catch(err => {
          console.log('Error tracking read - details.', err);
        });
    } catch (error) {
      console.warn('Exceção in read - details.', error);
      return false;
    }
  }

  async function fetchTracking(payload) {
    try {
      await api
        .put('/customer-relationship/sitel/v1/calls', payload, parameters)
        .then(res => {})
        .catch(err => {
          console.log('Error tracking call - popup.', err);
        });
    } catch (error) {
      console.warn('Exceção in tracking - Popup.', error);
      return false;
    }
  }

  async function getPayload() {
    const payload = {
      segment: '',
      market: '',
      nucleus: '',
      micro_market: '',
      lapidar: '',
      branch: '',
      state: '',
      cnpj: '',
    };

    const segment = localStorage.getItem('segment');
    const core = localStorage.getItem('core');
    const market = localStorage.getItem('market');
    const microMarket = localStorage.getItem('microMarket');
    const branch = localStorage.getItem('branch');
    const state = localStorage.getItem('state');
    const document = localStorage.getItem('storeDocument');

    if (
      segment &&
      core &&
      market &&
      microMarket &&
      branch &&
      state &&
      document
    ) {
      payload.segment = capitalizeFirstLetter(segment);
      payload.nucleus = core;
      payload.market = market;
      payload.micro_market = microMarket;
      payload.branch = branch;
      payload.state = state;
      payload.cnpj = formatCNPJ(document);
    } else {
      const responseStore = await loadDataMe();
      if (responseStore) {
        payload.segment = capitalizeFirstLetter(
          responseStore.resaleSegmentation,
        );
        payload.nucleus = responseStore.core;
        payload.market = responseStore.market;
        payload.micro_market = responseStore.microMarket;
        payload.branch = responseStore.branch;
        payload.state = responseStore.address.stateAbbreviation;
        payload.cnpj = formatCNPJ(responseStore.document);
      }
    }

    const summary = await getStoreSummary();
    if (summary) {
      payload.lapidar = capitalizeFirstLetter(summary);
    } else {
      payload.lapidar = 'Não inscrita';
    }

    return payload;
  }

  async function fetch() {
    let dataFetched = [];
    try {
      const payload = await getPayload();

      await api
        .post(
          '/customer-relationship/sitel/v1/banners',
          {
            filters: [payload],
          },
          parameters,
        )
        .then(async res => {
          if (res.data.data.length) {
            const notificationsFiltered = filterNotification(res.data.data);
            const notificationsOrdered = orderingNotifications(
              dataFetched,
              notificationsFiltered,
            );
            dataFetched = removeDuplicated(notificationsOrdered);
            const bannersFiltered = verifyBanner(res.data.data);
            setBanners(bannersFiltered);
            for (const item of bannersFiltered.slice(-5)) {
              await fetchTracking({ bulletinsid: item.id, cnpj: payload.cnpj });
            }
            for (const item of bannersFiltered.slice(-5)) {
              if (!item.hiperlinks && !item.content) {
                await fetchTrackingRead({
                  bulletinsid: item.id,
                  cnpj: payload.cnpj,
                });
              }
            }
          }
        })
        .catch(err => {
          console.log('Error get banner in page portal', err);
        });

      await api
        .post(
          '/customer-relationship/sitel/v1/popups',
          {
            filters: [payload],
          },
          parameters,
        )
        .then(async res => {
          if (res.data.data.length) {
            const notificationsFiltered = filterNotification(res.data.data);
            const notificationsOrdered = orderingNotifications(
              dataFetched,
              notificationsFiltered,
            );
            dataFetched = removeDuplicated(notificationsOrdered);
          }
        })
        .catch(err => {
          console.log('Error get popup - page portal', err);
        });

      await api
        .post(
          '/customer-relationship/sitel/v1/pushes',
          {
            filters: [payload],
          },
          parameters,
        )
        .then(async res => {
          if (res.data.data.length) {
            const notificationsFiltered = filterNotification(res.data.data);
            const notificationsOrdered = orderingNotifications(
              dataFetched,
              notificationsFiltered,
            );
            dataFetched = removeDuplicated(notificationsOrdered);
          }
        })
        .catch(err => {
          console.log('Error get data in push portal', err);
        });

      dispatch({ type: 'SET_NOTIFICATIONS', notifications: dataFetched });
    } catch (error) {
      console.warn('Exception in get data - portal page', error);
      return false;
    }
  }

  const verifyDateValid = value => {
    var todaysDate = new Date();

    if (!value.start_date && !value.end_date) return true;
    if (!value.start_date && value.end_date) {
      if (new Date(value.end_date) >= todaysDate) return true;
      return false;
    }
    if (value.start_date && !value.end_date) {
      if (new Date(value.start_date) <= todaysDate) return true;
      return false;
    }
    if (
      new Date(value.start_date) <= todaysDate &&
      new Date(value.end_date) >= todaysDate
    ) {
      return true;
    }
    return false;
  };

  function verifyBanner(data) {
    if (data.length > 0) {
      const items = data.filter(item => item.status === 'published');
      const itemsDateValid = items.filter(item => verifyDateValid(item));
      const recent = itemsDateValid.sort(
        (a, b) => new Date(a.date_published) - new Date(b.date_published),
      );
      return recent;
    }
    return null;
  }

  function filterNotification(data) {
    if (data.length > 0) {
      const items = data.filter(item => item.status === 'published');
      return items;
    }
    return [];
  }

  function orderingNotifications(old, data) {
    const newData = old.concat(data);
    const ordered = newData.sort(
      (a, b) => new Date(a.date_published) - new Date(b.date_published),
    );
    return ordered;
  }

  function removeDuplicated(data) {
    var reduced = [];

    data.forEach(item => {
      var duplicated =
        reduced.findIndex(redItem => {
          return item.id == redItem.id;
        }) > -1;

      if (!duplicated) {
        reduced.push(item);
      }
    });
    return reduced;
  }

  useEffect(() => {
    const items = [];
    if (banners.length > 0) {
      if (isShowPendency) {
        items.push({ type: 'pendency', active: true });
      }
      if (verifyRoles(roles, 'HUB') && hasHub) {
        items.push({ type: 'hub', active: true });
      }
      if (verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') && items.length < 2) {
        items.push({ type: 'order', active: true });
      }
      if (!localStorage.getItem('ownerid') && items.length < 2) {
        items.push({ type: 'users', active: true });
      }
    }
    setItemsSlider(items);
  }, [banners]);

  useEffect(() => {
    const interval = setInterval(() => {
      var iframes = document.querySelectorAll('iframe');
      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].id !== 'indecx-iframe') {
          iframes[i].parentNode.removeChild(iframes[i]);
        }
      }
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    var iframes = document.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].id !== 'indecx-iframe') {
        iframes[i].parentNode.removeChild(iframes[i]);
      }
    }
  }, [document]);

  function handleHideModal() {
    setModalOpenMessageExpiredInDays(false);
  }

  return (
    <PageContainer>
      <SideBar
        menuSelected={'Início'}
        hasPendenciOn={classificationReducer.pendenciesOn}
      >
        <Container>
          <Content>
            <HeaderContainer>
              <Header stores={storesState} banners={banners} />
            </HeaderContainer>
            <NavigationContainer>
              {banners.length > 0 && (
                <AreaBanner>
                  <CardSliderShowDefault banners={banners} />
                  <AreaTwoCards>
                    {isShowPendency &&
                      itemsSlider.find(
                        item => item.type === 'pendency' && item.active,
                      ) && (
                        <NavigationCard
                          title="Pendências"
                          icon="ic_pendencia_vermelho.svg"
                          onClick={() => history.push('/pendencias')}
                          ac
                          color="red"
                        >
                          <PendencyQuantity>
                            {numberOfPendingIssues === 1
                              ? `${numberOfPendingIssues} nova`
                              : `${numberOfPendingIssues} novas`}
                          </PendencyQuantity>
                        </NavigationCard>
                      )}
                    {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') &&
                      itemsSlider.find(
                        item => item.type === 'order' && item.active,
                      ) && (
                        <OrderContainerWeb>
                          <NavigationCard
                            className="w-100"
                            title="Pedido de Abastecimento"
                            icon="abastecimento.svg"
                          >
                            <RefuelButton
                              onClick={() => {
                                logEvent(
                                  analytics,
                                  'home_pedido_abastecimento',
                                );
                                dispatch(Creators.resetLogistic());
                                history.push('/criar-pedido');
                              }}
                            >
                              <span>Realizar Pedido</span>
                            </RefuelButton>
                          </NavigationCard>
                        </OrderContainerWeb>
                      )}
                    {!localStorage.getItem('ownerid') &&
                    itemsSlider.find(
                      item => item.type === 'users' && item.active,
                    ) ? (
                      <NavigationCard
                        iconWidth="40"
                        title="Usuários"
                        iconUI={<ContactIcon fontSize="large" />}
                      >
                        <EmployeesButtonContainer>
                          <TrainingsButton
                            onClick={() => {
                              dispatch({
                                type: 'ACTIVE_EMPLOYEE_MODAL',
                                activeModal: { employee: true, modal: true },
                              });

                              if (window.screen.width < 770) {
                                history.push('/cadastrar-funcionario');
                              }
                            }}
                          >
                            Cadastrar
                          </TrainingsButton>
                          <TrainingsButton
                            onClick={() => {
                              history.push('/usuarios');
                            }}
                          >
                            Listar
                          </TrainingsButton>
                        </EmployeesButtonContainer>
                      </NavigationCard>
                    ) : null}
                  </AreaTwoCards>
                </AreaBanner>
              )}
              <AreaOthersCards
                display={itemsSlider.find(
                  item => item.type === 'pendency' && item.active,
                )}
              >
                {isShowPendency && (
                  <NavigationCard
                    title="Pendências"
                    icon="ic_pendencia_vermelho.svg"
                    onClick={() => history.push('/pendencias')}
                    ac
                    color="red"
                  >
                    <PendencyQuantity>
                      {numberOfPendingIssues === 1
                        ? `${numberOfPendingIssues} nova`
                        : `${numberOfPendingIssues} novas`}
                    </PendencyQuantity>
                  </NavigationCard>
                )}
              </AreaOthersCards>
              <AreaOthersCards
                slider={itemsSlider.find(
                  item => item.type === 'order' && item.active,
                )}
                order={true}
              >
                {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') && (
                  <OrderContainerWeb>
                    <NavigationCard
                      className="w-100"
                      title="Pedido de Abastecimento"
                      icon="abastecimento.svg"
                    >
                      <RefuelButton
                        onClick={() => {
                          logEvent(analytics, 'home_pedido_abastecimento');
                          dispatch(Creators.resetLogistic());
                          history.push('/criar-pedido');
                        }}
                      >
                        <span>Realizar Pedido</span>
                      </RefuelButton>
                    </NavigationCard>
                  </OrderContainerWeb>
                )}
              </AreaOthersCards>
              {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') && (
                <OrderContainerMobile>
                  <NavigationCard
                    onClick={() => {
                      logEvent(analytics, 'home_pedido_abastecimento');
                      dispatch(Creators.resetLogistic());
                      history.push('/criar-pedido');
                    }}
                    title="Pedido de Abastecimento"
                    icon="abastecimento.svg"
                  />
                </OrderContainerMobile>
              )}
              <AreaOthersCards
                slider={itemsSlider.find(
                  item => item.type === 'users' && item.active,
                )}
              >
                {!localStorage.getItem('ownerid') ? (
                  <NavigationCard
                    iconWidth="40"
                    title="Usuários"
                    iconUI={<ContactIcon fontSize="large" />}
                  >
                    <EmployeesButtonContainer>
                      <TrainingsButton
                        onClick={() => {
                          dispatch({
                            type: 'ACTIVE_EMPLOYEE_MODAL',
                            activeModal: { employee: true, modal: true },
                          });

                          if (window.screen.width < 770) {
                            history.push('/cadastrar-funcionario');
                          }
                        }}
                      >
                        Cadastrar
                      </TrainingsButton>
                      <TrainingsButton
                        onClick={() => {
                          history.push('/usuarios');
                        }}
                      >
                        Listar
                      </TrainingsButton>
                    </EmployeesButtonContainer>
                  </NavigationCard>
                ) : null}
              </AreaOthersCards>
              {verifyRoles(roles, 'STATUS_DO_PEDIDO') && (
                <NavigationCard
                  iconWidth="60"
                  title="Status do Pedido"
                  icon="status_pedido.svg"
                  hasStatus={true}
                  loading={loading}
                >
                  {loading ? (
                    <LoadingStatusDesktop />
                  ) : orderMessage ? (
                    <OrderMessageError>
                      Os pedidos de abastecimento não estão disponíveis na sua
                      região
                    </OrderMessageError>
                  ) : (
                    <EmployeesStatusContainer>
                      <RequestStatus to={`/detalhes-do-pedido?id=${order.id}`}>
                        <span>Pedido {order.number}</span>
                        <ExpandMoreIcon style={IconStatusOrder} />
                      </RequestStatus>
                      <OrderCycle
                        occupationStatus={order.occupationStatus}
                        statusFromApi={order.status}
                        status={handleStatusText(order.status)}
                      />
                      <RefuelButton
                        hasStatus={true}
                        padding={'.5rem'}
                        to={'/lista-de-pedidos'}
                      >
                        <img
                          src="./assets/images/icons/historico_pedido.svg"
                          alt="Histórico de Pedido"
                          className="mr-2"
                        />
                        <span>Histórico de pedidos</span>
                      </RefuelButton>
                    </EmployeesStatusContainer>
                  )}
                </NavigationCard>
              )}
            </NavigationContainer>
          </Content>
        </Container>
      </SideBar>
      {showOrderModal ? (
        <OrderModal activeModalOrder={activeModalOrder} />
      ) : null}
      {showEmployeeModal ? <EmployeeModal /> : null}
      {visitData ? (
        <VisitModalController
          visitData={visitData}
          onClearVisit={() => setVisitData(null)}
        />
      ) : null}
      <NpsRelational />
      <OpenChatBot />
      <ModalExpiredInDays
        modalOpenMessage={modalOpenMessageExpiredInDays}
        handleHideModal={handleHideModal}
        days={loginReducer.expireInDays}
      />
    </PageContainer>
  );
}
export default function Portal() {
  return (
    <PendencyProvider>
      <Home />
    </PendencyProvider>
  );
}
